import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * Los tamaños de fuente del Kernel Visual (`--text-*`) se declaran aquí: sin
 * esto, tailwind-merge toma `text-nota` por un color y descarta el
 * `text-white` con el que choca -el botón primario pequeño salía con texto
 * oscuro sobre fondo vino-.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: { text: ["body", "h1", "h2", "h3", "micro", "nota"] },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
